/**
 * @voltxampere/engine — ERC rule: missing-ground (Sprint 56)
 *
 * Every circuit needs exactly one ground reference. The MNA solver
 * (planCircuit) ALREADY throws ValidationGroundMissingError when
 * isGround is unset on every net — this ERC rule catches the same
 * condition pre-solve so the UI can surface a hint without a Recovery
 * Center trip via the engine throw boundary.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const missingGroundRule = {
    id: "missing-ground",
    defaultSeverity: "error",
    requiresDCResult: false,
    check(circuit) {
        const grounds = circuit.nets.filter((n) => n.isGround);
        if (grounds.length === 1)
            return [];
        const violations = [
            {
                ruleId: "missing-ground",
                severity: "error",
                i18nKey: "erc.missing-ground.message",
                suggestionKey: "erc.missing-ground.suggestion",
                meta: {
                    groundCount: grounds.length,
                },
            },
        ];
        return violations;
    },
};
//# sourceMappingURL=missing-ground.js.map